<template>
  <div class="change-to-esim-page">
    <div class="change-to-esim-page__card">
      <div class="change-to-esim-page__title">{{ $t("esim_change_to_esim_title") }}</div>

      <div class="change-to-esim-page__phone-label">{{ $t("esim_change_phone_label") }}</div>

      <div class="change-to-esim-page__phone-number">
        <input
          v-model="physicalNumber"
          class="change-to-esim-page__phone-input"
          type="tel"
          inputmode="numeric"
          maxlength="19"
          minlength="7"
        />
        <!-- 
        <button
          type="button"
          class="change-to-esim-page__btn-contact"
          :aria-label="$t('esim_pick_from_contacts')"
          @click="handleOpenContact"
        >
          <img
            class="change-to-esim-page__contacts-icon"
            src="@/static/contacts32.png"
            width="24"
            height="24"
            alt=""
          />
        </button>
      -->
      </div>

      <div class="change-to-esim-page__section-title">
        {{ $t("esim_identity_verification") }}
      </div>

      <div class="change-to-esim-page__select-wrap">
        <button
          type="button"
          class="change-to-esim-page__select-row"
          @click="toggleIdentityDropdown"
        >
          <span class="change-to-esim-page__select-label">
            {{ $t(selectedIdentityOption) }}
          </span>
          <van-icon
            name="arrow-down"
            class="change-to-esim-page__select-arrow"
          />
        </button>

        <div
          v-if="showIdentityDropdown"
          class="change-to-esim-page__dropdown"
        >
          <button
            type="button"
            class="change-to-esim-page__dropdown-item"
            @click="selectIdentityOption('esim_ekyc_information')"
          >
            {{ $t("esim_ekyc_information") }}
          </button>
        </div>
      </div>
    </div>

    <div class="change-to-esim-page__fixed-bottom">
      <van-button
        block
        class="change-to-esim-page__next-btn"
        :disabled="!canNext || isChecking"
        @click="handleNext"
      >
        {{ $t("esim_next") }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Icon } from "vant";
import { ESIM_ORDER_FLOW } from "@/helpers/esimFlow";
import { CONSTANTS } from "@/helpers/constants";

export default {
  name: "ChangeToEsimMetfone",
  components: {
    [Icon.name]: Icon,
  },
  data() {
    return {
      physicalNumber: "",
      checkIsdn: false,
      // Only 1 option exists for "Identity verification"
      selectedIdentityOption: "esim_ekyc_information",
      showIdentityDropdown: false,
      isChecking: false,
    };
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    canNext() {
      return (
        this.physicalNumber != null &&
        this.physicalNumber.toString().trim().length > 0
      );
    },
  },
  created() {
    this.$store.dispatch("headerStore/setTitle", "esim_change_to_esim_title");
  },
  watch: {
    $route: {
      handler() {
        this.$store.dispatch("headerStore/setTitle", "esim_change_to_esim_title");
      },
      immediate: true,
    },
  },
  methods: {
    toggleIdentityDropdown() {
      // Only one option exists; dropdown is purely visual/UX.
      this.showIdentityDropdown = !this.showIdentityDropdown;
    },
    selectIdentityOption(option) {
      this.selectedIdentityOption = option;
      this.showIdentityDropdown = false;
    },

    //Hiện tại chưa dùng đến
    handleOpenContact() {
      console.log("Open contact picker");
      if (process.env.VUE_APP_BYPASS_NATIVE_API === "false") {
        this.$bridge.callHandler("getContact").then((data) => {
          console.log("Contact data:", data);
          if (data && data.phone) {
            // Copy-like behavior from confirm-purchase.vue:
            // - normalize digits
            // - format with spaces
            // - validate number by regex
            this.physicalNumber = this.formatPhoneNumberTwo(
              data.phone.replace(/\D/g, "")
            );

            let rep = this.formatSpacingPhoneNumber(this.physicalNumber);
            var formatPhoneNumberCheck = this.regexMetfone(rep);
            this.checkIsdn = !formatPhoneNumberCheck;
          }
        });
      } else {
        const data = {
          name: "Test Contact" + Math.floor(1000 + Math.random() * 9000),
          phone:
            "+855" + Math.floor(10000000 + Math.random() * 90000000),
        };
        console.log("Dev mode: Contact picker not available", data);
        this.physicalNumber = this.formatPhoneNumberTwo(
          data.phone.replace(/\D/g, "")
        );

        let rep = this.formatSpacingPhoneNumber(this.physicalNumber);
        var formatPhoneNumberCheck = this.regexMetfone(rep);
        this.checkIsdn = !formatPhoneNumberCheck;
      }
    },
    formatPhoneNumberTwo(phoneNumber) {
      let cleanedNumber = phoneNumber;
      if (cleanedNumber.length >= 3) {
        cleanedNumber = cleanedNumber.replace(/\s+/g, ""); // Remove illegal characters
        if (cleanedNumber.length > 3)
          cleanedNumber = cleanedNumber.replace(/.{3}/, "$& "); // Add space at pos.
        if (cleanedNumber.length > 7)
          cleanedNumber = cleanedNumber.replace(/.{7}/, "$& ");
        if (cleanedNumber.length >= 11 && cleanedNumber.length <= 12) {
          cleanedNumber = cleanedNumber.replace(/.{13}/, "$& ");
        } else {
          cleanedNumber = cleanedNumber.replace(/.{11}/, "$& ");
        }
        if (cleanedNumber.length >= 15 && cleanedNumber.length <= 16) {
          cleanedNumber = cleanedNumber.replace(/.{17}/, "$& ");
        } else {
          cleanedNumber = cleanedNumber.replace(/.{15}/, "$& ");
        }
        return cleanedNumber;
      }
      return phoneNumber;
    },
    regexMetfone(phone) {
      if ((phone && phone.length < 8) || phone.length > 16) return false;
      let regex =
        /^(?:00855|855|0)?(31|60|66|67|68|71|88|90|97|236|246|256|266|326|336|346|356|366|426|436|446|526|536|546|556|626|636|646|656|726|736|746|756)\d+$/;
      let result = regex.test(phone);
      return result;
    },
    formatSpacingPhoneNumber(phone) {
      return phone.replace(/ /g, "");
    },
    async handleNext() {
      if (!this.canNext || this.isChecking) return;

      const isdn = (this.physicalNumber || "").replace(/\D/g, "");
      const token = this.defaultParam?.token || CONSTANTS.TOKEN;
      const locale = this.defaultParam?.locale || "en_US";
      const accountABA = this.profile?.appId || "";

      this.isChecking = true;
      try {
        const res = await this.$store.dispatch("esimMetfoneStore/checkChangeSimIsdn", {
          token,
          locale,
          accountABA,
          isdn,
        });

        const errorMessage =
          res?.data?.message || res?.message || "Unknown error";

        const errorCode = Number(res?.data?.errorCode);
        console.log("errorCode", errorCode);
        // Rule: errorCode = 0 => success, errorCode = 1 => wrong
        if (errorCode !== 0) {
          this.$notify({ code: errorCode || 1, message: errorMessage });
          return;
        }

        // Persist physical MSISDN for later APIs (checkMatchInfoChangeSim, eKYC).
        await this.$store.dispatch("esimBuyStore/orderDetail", {
          esimOrderFlow: ESIM_ORDER_FLOW.CHANGE,
          esimIsdn: isdn,
          esimPriceIsdn: 0,
          esimPackageCode: null,
          esimPricePackage: 0,
          esimPackageName: null,
          totalPrice: 0,
        });

        this.$router.push({ path: "/register-infor" });
      } catch (e) {
        this.$notify({
          code: 1,
          message:
            e?.message ||
            e?.response?.data?.message ||
            "Unknown error",
        });
      } finally {
        this.isChecking = false;
      }
    },
  },
};
</script>

<style scoped>
.change-to-esim-page {
  min-height: 100vh;
  background: #eeeeee;
  padding: 18px 16px 120px;
  box-sizing: border-box;
}

.change-to-esim-page__card {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px 16px 18px;
}

.change-to-esim-page__title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
}

.change-to-esim-page__subtitle {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 12px;
}

.change-to-esim-page__phone-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
}

.change-to-esim-page__phone-number {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.change-to-esim-page__phone-input {
  width: 85%;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
}

.change-to-esim-page__btn-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 5px;
  border: 0;
  background: transparent;
  flex-shrink: 0;
}

.change-to-esim-page__contacts-icon {
  display: block;
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.change-to-esim-page__copy-icon {
  color: #c41627;
  font-size: 16px;
  line-height: 1;
}

.change-to-esim-page__section-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #111827;
}

.change-to-esim-page__select-wrap {
  position: relative;
}

.change-to-esim-page__select-row {
  width: 100%;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 8px;
  padding: 0 12px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.change-to-esim-page__select-row:active {
  opacity: 0.92;
}

.change-to-esim-page__select-row {
  border: 1px solid #e5e7eb;
  color: #6b7280;
}

.change-to-esim-page__select-label {
  font-size: 14px;
  color: #6b7280;
}

.change-to-esim-page__select-arrow {
  color: #6b7280;
}

.change-to-esim-page__dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: 46px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  z-index: 20;
  overflow: hidden;
}

.change-to-esim-page__dropdown-item {
  width: 100%;
  background: transparent;
  border: 0;
  height: 42px;
  padding: 0 12px;
  text-align: left;
  font-size: 14px;
  color: #111827;
}

.change-to-esim-page__dropdown-item:active {
  background: rgba(196, 22, 39, 0.08);
}

.change-to-esim-page__fixed-bottom {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 18px;
  z-index: 10;
}

.change-to-esim-page__next-btn {
  background: #c41627;
  border-radius: 10px;
  height: 46px;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}
</style>

